import React, { useState } from 'react';
import { Tag, Checkbox } from 'antd';
import { CheckboxChangeEvent } from 'antd/es/checkbox';

import styles from './FlagCheckbox.module.less';

type Props = {
  label: string;
  checked?: boolean;
  onChange: (checked: boolean) => Promise<void>;
};

export default function FlagCheckbox(props: Props) {
  const { label, checked, onChange } = props;
  const [loading, setLoading] = useState(false);

  const handleChange = async (event: CheckboxChangeEvent) => {
    setLoading(true);
    try {
      await onChange(event.target.checked);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Tag className={styles.flagTag}>
      <Checkbox checked={!!checked} disabled={loading} onChange={handleChange}>
        {label}
      </Checkbox>
    </Tag>
  );
}
